"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchRecordings = fetchRecordings;
exports.saveRecordings = saveRecordings;
exports.saveRecording = saveRecording;
exports.deleteRecording = deleteRecording;
exports.fetchAntecedents = fetchAntecedents;
const events_1 = require("../events");
const api_1 = require("../utils/api");
async function fetchRecordings({ org, mod, patientId, formId, schemaId }) {
    const sId = schemaId ? schemaId : formId;
    const { data } = await api_1.api.get(`/recordings?organization=${org}&module=${mod}&form=${formId}&schema=${sId}&patient=${patientId}`);
    return data.map(normalizeRecording);
}
function saveRecordings({ org, mod, patientId, data }) {
    return api_1.api.post(`/recordings/batch?organization=${org}&module=${mod}&patient=${patientId}`, data);
}
async function saveRecording({ org, mod, patientId, formId, schemaId, recording }) {
    const sId = schemaId ? schemaId : formId;
    const { data } = await api_1.api.post(`/recordings?organization=${org}&module=${mod}&patient=${patientId}`, { form: formId, schema: sId, ...recording });
    return normalizeRecording(data);
}
function deleteRecording({ org, mod, patientId, formId, schemaId, timestamp }) {
    const sId = schemaId ? schemaId : formId;
    return api_1.api.delete(`/recordings?organization=${org}&module=${mod}&patient=${patientId}&form=${formId}&schema=${sId}&timestamp=${timestamp}`);
}
async function fetchAntecedents({ org, mod, patientId, queries, savedAntecedents }) {
    let url = `events/${patientId}/last?organization=${org}&module=${mod}&includeDeleted=true`;
    for (const query of queries) {
        url += `&i=${(0, events_1.mapQueryToString)(query)}`;
    }
    const { data } = await api_1.api.get(url);
    if (data === null) {
        return [];
    }
    return data.filter(event => !event.deleted ||
        savedAntecedents.some(antecedent => antecedent.sid === event.sid &&
            antecedent.timestamp === event.timestamp));
}
function normalizeRecording({ antecedents, attachments, ...recording }) {
    return {
        ...recording,
        attachments: attachments || [],
        antecedents: antecedents || []
    };
}
